import React from "react"

import { BreadcrumbJsonLd, LogoJsonLd } from "gatsby-plugin-next-seo"
import { useStaticQuery, graphql } from "gatsby"

const AboutPageStuctredDataUsingJsonLd = () => {
  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "siteSettings" } }) {
        frontmatter {
          logo {
            publicURL
          }
        }
      }
    }
  `)

  const { publicURL } = data.markdownRemark.frontmatter.logo

  return (
    <>
      <LogoJsonLd
        logo={`https://www.muhammadilyaskpada.com${publicURL}`}
        url="https://www.muhammadilyaskpada.com"
      />

      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "Homepage",
            item: "https://muhammadilyaskpada.com",
          },
          {
            position: 2,
            name: "About page",
            item: "https://muhammadilyaskpada.com/about",
          },
          {
            position: 3,
            name: "Blog Index",
            item: "https://muhammadilyaskpada.com/blog",
          },
          {
            position: 4,
            name: "Academy",
            item: "https://muhammadilyaskpada.com/academy",
          },
          {
            position: 5,
            name: "Contact Page",
            item: "https://muhammadilyaskpada.com/contact",
          },
          {
            position: 6,
            name: "Advertisement Landing Page for International Copywriting Academy",
            item: "https://muhammadilyaskpada.com/academy/landing",
          },
          {
            position: 7,
            name: "Email Subscription Page",
            item: "https://muhammadilyaskpada.com/email",
          },
        ]}
      />
    </>
  )
}

export default AboutPageStuctredDataUsingJsonLd
